import api from '@/utils/api';
import upload from '@/utils/upload';

const { baseApi } = window.GlobalConfig;

export const QueryFactorPage = data => {
    return api.post(`${baseApi}/expFactor/getExpFactorList`, data);
};

export const SaveFactor = data => {
    return api.post(`/expFactor/addExpFactor`, data);
};

export const UpdateFactor = data => {
    return api.post(`/expFactor/updateExpFactor`, data);
};

export const DeleteFactor = ({ factorId }) => {
    return api.get(`/expFactor/deleteExpFactor/${factorId}`);
};

export const QueryFactorGorup = data => {
    return api.post(`${baseApi}/expGroup/getExpGroupList`, data);
};

export const QueryFactorByGroup = data => {
    return api.post(`${baseApi}/expGroupFactorRel/getExpGroupFactorRelListByGroupId`, data);
};

export const UpdateFactorGroup = data => {
    return api.post(`${baseApi}/expGroup/updateExpGroup`, data);
};

export const AddFactorGroup = data => {
    return api.post(`${baseApi}/expGroup/addExpGroup`, data);
};

export const linkFactor = data => {
    return api.post(`${baseApi}/expGroupFactorRel/saveExpGroupFactorRel`, data);
};

export const removeFactor = data => {
    return api.post(`${baseApi}/expGroupFactorRel/deleteExpGroupFactorRel`, data);
};

export const updateFactor = data => {
    return api.post(`${baseApi}/expGroupFactorRel/updateExpGroupFactorRel`, data);
};

export const queryUserGroup = data => {
    return api.post(`${baseApi}/user/getUserListByGroupId`, data);
};

export const UpdateUserGroup = data => {
    return api.post(`${baseApi}/expGroupUserRel/saveExpGroupUserRelByGroupId`, data);
};

export const deleteGroup = data => {
    return api.get(`${baseApi}/expGroup/deleteExpGroup/${data.groupId}`);
};

export const returnScore = data => {
    return api.post(`${baseApi}/returnTarget/getReturnTargetScorePage`, data);
};

export const returnUserScore = data => {
    return api.post(`${baseApi}/returnTarget/getReturnTargetScorePage`, data);
};

export const QueryCompelete = data => {
    return api.post(`${baseApi}/incomeTargetUserDirect/getIncomeTargetUserDirectFinishRatePage`, data);
};

export const QuerySaleScore = data => {
    return api.post(`${baseApi}/incomeTargetUserDirect/getIncomeTargetUserDirectScore4SettlePage`, data);
};

export const QuerySaleConfig = data => {
    return api.post(`${baseApi}/incomeTargetUserDirect/getIncomeTargetUserDirectScorePage`, data);
};

// 归档
export const MarkDocument = data => {
    return upload.post(`/performance/saveIncomeSaleScoreArchive`, data);
};

// 新销售得分
export const QueryPerformanceSale = data => {
    return api.post(`/performance/getPerformanceArchiveScorePage`, data);
};

// 查询动态表头
export const QueryPerformaceColumns = data => {
    return api.post(`/performanceArchiveGroupFactorRel/getFactorList4ScoreHeader`, data);
};

// 查看因子
export const QueryFactorById = ({ groupId }) => {
    return api.get(`${groupId}`);
};
